import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AppSettings {
  public static Appversion = '1.3';
  public static IdleTimeInSec = environment.IdleTimeInSec; // set max idle time
  public static Platform = 'Web';
  public static projMode = 'dev1';
  public static DEBUG_MODE = true;
  public static AJAX_INTERVAL_TIMEOUT = 8000;
  public static APPID = 'ICE';
  public static RSA_KEY_SIZE = 1024;
  public static PLATFORM_ID = 2; //0 android and 1 for iOS.... 2 for web
  public static AES_KEY_LENGTH = 16;
  public static AES_IV_LENGTH = 16;
  public static AES_KEY_SIZE = 128;
  public static MOBILE_SCREEN_WIDTH = 768;
  public static ORG_ID = 'uvwredqq'; //For TM validation set matrix
  public static AES_KEY = 'erdfgtyhgbnjuyth';
  public static AES_IV = 'hyefvnhredhjuyt';
  public static occupencyList: any;
  public static domain: 'https://HYGZ7R1.pyramidconsultinginc.com:5152/';
  public static IovationBBKey = '';
  public static TmSession = '';
  // public static tmService = 'https://h.online-metrix.net/fp/tags?org_id=uvwredqq&session_id=';
  public static tmService = 'https://cdn2.intercambioexpress.com/tags.js?org_id=uvwredqq&session_id=';
  // public static tmqueryService = 'https://h-api.online-metrix.net/api/session-query?org_id=uvwredqq&api_key=z6rgid0ty4exjuqm&session_id={query}&service_type=session&event_type=payment&policy=payment';

  public static jsontitlefile = '../assets/Json/pagetitle.json';
  public static pagetitleFilePath = '../assets/Json/pagetitle.json';
  public static BaseCountry = 'US';
  public static BaseCountryCurrency = 'USD';
  public static fractionDigit = 2;
  // public static specialChar = '^[a-zA-Zñáéíóúü0-9 ]*$' ;//'^[a-zA-Zñáéíóúü0-9]* {1}[a-zA-Zñáéíóúü0-9]*$';
  // public static specialChar = '^[a-zA-Zñáéíóúü0-9]+( [a-zA-Zñáéíóúü0-9_]+)*';
  public static specialChar = '[a-zA-Zñáéíóúü0-9 ]*$';
  public static AddressSpecialChar = '[a-zA-Z0-9 ]*$';
  public static validNamePattern = '[a-zA-Z ]*$';

  public static validEmail = '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$';
  public static passwordSpecialCharPattern = '([#?()<>\[.{}!:;@=/$~%,"`’_+^&|*-]|\\\\|]|\')';
  public static validPasswordPattern = '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?' + AppSettings.passwordSpecialCharPattern + ').{8,15}$';

  public static get_current_carttype = '';
  public static imagefolder = 'assets/images/';

  public static androidPhone = "https://play.google.com/store/apps/details?id=com.intercambio.intersend";
  public static androidTab = "https://play.google.com/store/apps/details?id=com.intercambio.intersend";
  public static iPhonePhone = 'https://apps.apple.com/us/app/id1518222946';
  public static iPhoneTab = 'https://apps.apple.com/us/app/id1518222946';  

  // ---- Client Services----
  public static BASE_URL = environment.apiBaseUrl + ':9008/CountryImags';
  public static baseImageURL = environment.apiBaseUrlRes + environment.baseImageURLPort + '/ICEMaster.svc/GetICEImage';
  public static FraudDetectionService = environment.apiBaseUrl + environment.FraudDetectionServicePort + '/MicroServiceFraudDetection.svc';
  public static loginService = environment.apiBaseUrl + environment.loginServicePort + '/MicroServiceLogin.svc';
  public static forgot_pass_soap_url = environment.apiBaseUrl + environment.forgot_pass_soap_urlPort + '/MicroServiceForgotPassword.svc';
  public static shareCodeURL = environment.apiBaseUrl + environment.shareCodeURLPort + '/MicroServiceShare.svc';
  public static messageCenterserviceURL = environment.apiBaseUrl + environment.messageCenterserviceURLPort + '/Notification.svc';
  public static ICEUserMgmtService = environment.apiBaseUrl + environment.ICEUserMgmtServicePort + '/ICEUserMgmt.svc';
  public static BeneficiaryService = environment.apiBaseUrl + environment.BeneficiaryServicePort + '/MicroServiceBeneficiary.svc';
  public static ICEStoreLocatorService = environment.apiBaseUrl + environment.ICEStoreLocatorServicePort + '/StoreLocator.svc';
  public static ICEMasterService = environment.apiBaseUrl + environment.ICEMasterServicePort + '/ICEMaster.svc';
  public static AgentManagementService = environment.apiBaseUrl + environment.AgentManagementServicePort + '/AgentService.svc';
  public static getBranchesService = environment.apiBaseUrl + environment.getBranchesServicePort + '/BranchService.svc';
  public static get_debit_card_url = environment.apiBaseUrl + environment.get_debit_card_urlPort + '/GetCardFromWallet.svc';
  public static add_debit_card_url = environment.apiBaseUrl + environment.add_debit_card_urlPort + '/AddCardToWallet.svc';
  public static get_saved_stores_url = environment.apiBaseUrl + environment.get_saved_stores_urlPort + '/StoreWallet.svc';
  public static OrderProcessingService = environment.apiBaseUrl + environment.OrderProcessingServicePort + '/OrderProcessingService.svc';
  public static CartActionItemServices = environment.apiBaseUrl + environment.CartActionItemServicesPort + '/CartActionItemServices.svc';
  public static orderReceiptURL = environment.apiBaseUrl + environment.orderReceiptURLPort + '/OrderReceipt.svc/rest/';
  public static transactionService = environment.apiBaseUrl + environment.transactionServicePort + '/TransactionService.svc';
  public static ICEDocumentMgmt = environment.apiBaseUrl + environment.ICEDocumentMgmtPort + '/ICEDocumentMgmt.svc';
  public static registercaronICEUrl = environment.registerCardBaseUrl + '/agents/rptOrder/Pyramid/FundingEnrollment.aspx?';
  public static verifyCard = environment.cardVerificationBaseUrl;
  public static baseContentURL = environment.apiBaseUrl + environment.baseContentURLPort + '/';
  public static GetMyIPService = environment.apiBaseUrl + environment.GetMyIPServicePort + '/ICEMaster.svc/GetMyIP';
  public static GetCardImageURL = environment.apiBaseUrl + environment.GetCardImageURLPort + '/ICEMaster.svc/GetFundingCards';
  public static mapkey = environment.mapKey;

  public static mapurl = 'https://maps.googleapis.com/maps/api/js?key=' + AppSettings.mapkey;
  public static mapgeocodeurl = 'https://maps.googleapis.com/maps/api/geocode/json?key=' + AppSettings.mapkey + '&latlng=';
  public static redStatus = ['PMT_PENDING', 'PMT_CNCLD', 'PMT_FAILED', 'PMT_CNCL_PENDING', 'PMT_PAID_TransationHistory', 'PMT_STATUS_DOC_REQUIRED'];
  public static minLength = 2;
  public static minLengthSeven = 7;
  public static addressminLength = 4;
  public static phoneminLength = 10;
  public static phonemaxLength = 10;
  public static zipminLength = 5;
  public static zipmaxLength = 5;
  public static getCountryUrl(countryCode) {
    return this.baseImageURL + '/ConutryImage/' + countryCode + '.Jpeg';
  }
}

export enum enumStatusCodeList {
  SUCCESS = 10000,
  SUCCESS_FOR_VERIFICATION = 10100,
  FAIL = 10001,
  UserIsAlreadyExist = 10002,
  UserNotFound = 10003,
  PasswordIsInvalid = 10004,
  PhoneNotVerified = 10005,
  EmailNotVerified = 10006,
  EmailAndPhoneNotVerified = 10007,
  UserNotLinked = 10008,
  UserIsAlreadyExistWithICE = 10009,
  RegistrationCodeIsInvalid = 10010,
  InvalidOTP = 10011,
  AESkeyNotFound = 10012,
  BeneficiaryIsAlreadyExist = 10013,
  OTPExpier = 10015,

  userProfileUpdated = 10019,
  TokenInvalidOrExpired = 20001,
  fieldsRequiredInOrder = 8001,
  ItemNotPresentInCart = 10028,
  resgistrationWithoutShare = 10032,
  Transactionnotfound = 9060,
  Transactioninprocess = 9065,
  OutOfAreaOfService = 9950,
  VerifyDevice = 10046, 
  DataNotFound = 10034,
  ComplianceError = 10040,

  InvalidField = 3000,
  Declined = 3001,
  NotSufficientFunds = 3002,
  PaymentProcessorError = 3004,
  Timeout = 3005,
  FundingIsNotDebitCard = 3006,
  InvalidCardRegisterRequest = 3007,
  docAlreadyUploaded = 10025,
  Invalid_bank_account1 = 9071,
  Invalid_bank_account2 = 9072,
  loylty_already_linked = 10020,
  loylty_invalid_card_num = 10018,
  loylty_timeout = 10048

}
export enum PaymentType {
  None = 0,
  DebitCard = 30,
  PayAtStore = 10
}
export enum verficationMethodType {
  SMS = 1,
  EMAIL = 2,
  LASTTRANSACTION = 3,
  SMS_EditProfile = 4,
  Loyaltylink_EditProfile = 5
}
export enum PickupType {
  'Office' = 1
}

export class OrderData {
  OrderNo: string = '';
  BenificiaryId: string = '';
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_common/constants/app.constants.ts